<template>
  <el-dialog
    title="Choose investor"
    :visible.sync="visible"
    :close-on-click-modal="false"
  >
    <div v-loading="fetchInProgress || processing">
      <el-form label-position="top">
        <el-form-item>
          <el-input
            ref="input"
            v-model="search"
            class="inline-input"
            placeholder="Search"
            @input="debouncedSearch"
          />
        </el-form-item>
      </el-form>

      <p
        v-for="error in errors"
        :key="error"
        class="validation-text text-danger"
      >
        {{ error }}
      </p>

      <el-table v-loading="fetchInProgress" :data="investors">
        <el-table-column label="Company" prop="name">
          <template slot-scope="{ row }">
            <a href @click.prevent="pickInvestor({ investor: row })">
              {{ row.name }}
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import http from 'services/http'

export default {
  props: {
    organizationId: { type: String },
  },
  data() {
    return {
      visible: false,
      processing: false,
      fetchInProgress: false,
      search: '',
      investors: [],
      debouncedSearch: null,
      errors: [],
    }
  },
  created() {
    this.debouncedSearch = _.debounce(this.fetch, 200)
  },
  methods: {
    open() {
      const self = this
      this.visible = true
      this.fetchInProgress = false
      this.processing = false
      this.investors = []

      self.$nextTick(function () {
        self.$el.querySelector('input').focus()
      })
    },

    close() {
      this.visible = false
    },

    async pickInvestor({ investor }) {
      this.processing = true
      const url = `/organizations/${this.organizationId}/set-investor`
      const data = { investor_id: investor.id }
      try {
        await http.postAuthed(url, data)
        this.$emit('picked', { investor })
        this.close()
      } catch (error) {
        throw error
      } finally {
        this.processing = false
      }
    },

    async fetch(text) {
      if (!text) {
        this.investors = []
        return
      }
      this.fetchInProgress = true
      const url = '/investors'
      console.log(' => performSearch', text)
      console.log(' => GET ', url)
      const request = http.getAuthed(url, { search: text })
      try {
        const response = await request
        this.investors = response.data.results
      } finally {
        this.fetchInProgress = false
      }
    },
  },
}
</script>
